import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;